import { Controller } from "@hotwired/stimulus"
import { burstMilestoneConfetti } from "../utils/milestone_confetti"

export default class extends Controller {
    static targets = ["toast"]
    static values = { celebration: String, variant: String }

    connect() {
        this.existingToast = document.querySelector(".milestone-ack-toast")
        if (this.existingToast && this.existingToast !== this.element) {
            this.existingToast.remove()
        }
        if (this.celebrationValue === "confetti") {
            this.burstConfetti()
        }
    }

    disconnect() {
        this.confettiLayer?.remove()
    }

    dismiss(event) {
        let button = event.currentTarget
        let milestoneId = button.dataset.milestoneId
        let batch = button.dataset.batch
        let preview = button.dataset.preview
        if (this.hasToastTarget) {
            this.toastTarget.remove()
        }
        this.confettiLayer?.remove()
        this.element.remove()
        if (preview === "true") return

        let params = new URLSearchParams()
        if (batch === "true") {
            params.set("batch", "true")
        } else if (milestoneId) {
            params.set("milestone_id", milestoneId)
        }
        fetch(`/milestones/dismiss_acknowledgment?${params.toString()}`, {
            method: "POST",
            headers: {
                "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
            }
        }).catch(() => {})
    }

    preview(event) {
        event.preventDefault()
        document.querySelector(".milestone-ack-toast")?.remove()
        fetch("/milestones/preview_celebration", {
            method: "POST",
            headers: {
                "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
                "Accept": "text/html"
            }
        })
            .then((response) => response.text())
            .then((html) => {
                document.body.insertAdjacentHTML("beforeend", html)
            })
            .catch(() => {})
    }

    burstConfetti() {
        this.confettiLayer = burstMilestoneConfetti(this.variantValue)
    }
}
